import styled from 'styled-components';
import { Header } from 'semantic-ui-react'

export const SectionTitle = styled(Header)`
  font-size: 24px !important;
  font-weight: 400 !important;
  color: #333 !important;
  margin-top: 24px !important;
  margin-bottom: 16px !important;
`
export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px 24px;
  align-items: end;
`
export const FieldsGridAnimalGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px 24px;
  align-items: end;
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  gap: 4px;
  button {
    background: #e8e8e8 !important;
  }
`

export const FieldLabel = styled.label`
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: baseline;
  gap: 6px;

  .icon {
    margin: 0 !important;
    font-size: 17px !important;
  }
`

export const FieldValue = styled.div`
  background-color: #e8e8e8;
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  min-height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
`